import { getSession } from '@/core/auth/supabase-auth';
import type { ChatPageContext } from '../types';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

const MAX_HISTORY = 8;

/** POST the recent conversation to the backend assistant and return its reply. */
export async function sendChatMessage(
  messages: ChatMessage[],
  step: string | null,
  lang: string,
  context?: ChatPageContext,
): Promise<string> {
  const session = await getSession();
  const token = session?.access_token;
  if (!token) throw new Error('not-authenticated');

  const hasContext = !!(context && ((context.fields && context.fields.length) || context.dataProfile));
  const base = import.meta.env.VITE_API_URL || '';
  const res = await fetch(`${base}/api/chatbot/message`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      messages: messages.slice(-MAX_HISTORY),
      step,
      lang,
      ...(hasContext ? { context } : {}),
    }),
  });
  if (!res.ok) throw new Error(`chat-failed-${res.status}`);
  const data = (await res.json()) as { reply: string };
  return data.reply;
}
